import { NewUser } from '../../../secure/user-management/scripts/user-management.entities';

declare var $: any;

export class RequestAccountPage {

    affiliationSelect: JQuery<HTMLElement>;
    siteInfoContainer: JQuery<HTMLElement>;
    siteInfovalue: JQuery<HTMLElement>;

    requestAccountBtn: JQuery<HTMLElement>;

    errorMessageAll: JQuery<HTMLElement>;
    submitSpinner: JQuery<HTMLElement>;

    recaptchaPublicKey: string;
    recaptchaWidgetId: number = -99;
    recapthcaToken: string;
    constructor(captchaSiteKey: string) {      
        $(() => {
            this.affiliationSelect = $('[name="Input.AffiliationId"]');
            this.siteInfoContainer = $('#site-info-container');
            this.siteInfovalue = $('#Input_SiteInfo');
            this.recaptchaPublicKey = captchaSiteKey;
            this.requestAccountBtn = $("#request-account-btn");

            this.errorMessageAll = $("#all-error-message");
            this.submitSpinner = $("#submit-spinner");

            this.initializeListeners();
         
        })
    }

    initializeListeners(): void {

        const clincalSiteId = 5;

        this.affiliationSelect.on("changed.bs.select", () => {

            const selectedValue = parseInt(this.affiliationSelect.val() as string);

            if (selectedValue === clincalSiteId) {
                this.siteInfoContainer.removeClass("d-none");
            }
            else {
                this.siteInfoContainer.addClass("d-none");
                this.siteInfovalue.val("");
            }
        });

        this.requestAccountBtn.on("click", async (e) => {
            e.preventDefault();        
            let isValid = this.validateForm();
            const recaptchaToken = this.recaptchaPublicKey;
            if (isValid) {
                let accountRequest: NewUser = this.createAccountRequest();
                this.requestAccountBtn.addClass("d-none");
                this.submitSpinner.removeClass("d-none");
                await this.submitForm(accountRequest, recaptchaToken);
            }
            else {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
            }
        })
    }

    /*verifyReCaptcha(): boolean {
        let isValid = true;

        let response = grecaptcha.getResponse();

        if (!response) {
            isValid = false;
            $("#recaptcha-error-msg").removeClass('d-none');
        }
        else {
            this.recapthcaToken = response;
            $("#recaptcha-error-msg").addClass('d-none');
        }

        return isValid;
    }*/

    
    private validateForm(): boolean {
        let isValid = true;

        $(".required:visible").toArray().forEach(element => {
            let errorMessage = $(element).parent().find(".text-danger");

            let inputField = $(element).siblings("input").not(".email-input .tlcRole-input .siteInfo-input").first();
            if (inputField.length != 0) {
                let val = <string>inputField.val();
                if (!val) {
                    isValid = false;
                    errorMessage.removeClass("d-none");
                }
                else {
                    errorMessage.addClass("d-none");
                }
            }

            let emailInput = $(element).siblings(".email-input").first();
            if (emailInput.length != 0) {
                let val = <string>emailInput.val();
                if (!val) {
                    isValid = false;
                    errorMessage.removeClass('d-none');
                }
                else {
                    let trimmedVal = val.trim();
                    if (trimmedVal.includes(" ") || !trimmedVal.includes("@")) {
                        isValid = false;
                        errorMessage.removeClass('d-none');
                    }
                    else {
                        errorMessage.addClass("d-none");
                    }
                }
            }

            let selectField = $(element).parent().find("select").first();
            if (selectField.length != 0) {
                let val = <string>selectField.val();
                if (!val) {
                    isValid = false;
                    errorMessage.removeClass("d-none");
                }
                else {
                    errorMessage.addClass("d-none");
                }
            }
        });      

        if (isValid) {
            this.errorMessageAll.addClass("d-none");

        }
        else {
            this.errorMessageAll.removeClass("d-none");
        }


        return isValid;
    }
  

    private createAccountRequest(): NewUser {
        let accountRequest = new NewUser();

        // Personal Information
        let email = <string>$("#Input_Email").val();
        if (email) accountRequest.Email = email.trim();

        let firstName = <string>$("#Input_FirstName").val();
        if (firstName) accountRequest.FirstName = firstName.trim();

        let lastName = <string>$("#Input_LastName").val();
        if (lastName) accountRequest.LastName = lastName.trim();

        let orgName = <string>$("#Input_Organization").val();
        if (orgName) accountRequest.Organization = orgName.trim();

        let tlcRole = <string>$("#Input_TlcRole").val();
        if (tlcRole) accountRequest.TLCRole = tlcRole.trim();

        // Affiliation and Site Info
        let affiliationId = <string>$("#Input_AffiliationId").val();
        if (affiliationId) {
            let affId = parseInt(affiliationId);
            if (affId) accountRequest.AffiliationId = affId;
        }

        let siteInfo = <string>$("#Input_SiteInfo").val();
        if (siteInfo) accountRequest.SiteInfo = siteInfo.trim();

        //Trial Access
        accountRequest.LDNAccess = $("#Input_LDNAccess").is(":checked") ? 1 : 0;
        accountRequest.GLP1Access = $("#Input_GLP1Access").is(":checked") ? 1 : 0;
        accountRequest.BariAccess = $("#Input_BariAccess").is(":checked") ? 1 : 0;
        accountRequest.SGBAccess = $("#Input_SGBAccess").is(":checked") ? 1 : 0;

        accountRequest.LDNFinAccess = 0;
        accountRequest.GLP1FinAccess = 0;
        accountRequest.BariFinAccess = 0;
        accountRequest.SGBFinAccess = 0;

        accountRequest.StatusId = 1;
        //console.log(accountRequest);
        return accountRequest;
    }

    private async submitForm(accountRequest: NewUser, recaptchaToken: string): Promise<void> {

        let result: any
        try {
            result = await $.ajax({
                url: '?handler=RequestNewAccount',
                method: "POST",              
                headers: {
                    "RequestVerificationToken":
                        $('input[name="__RequestVerificationToken"]').val()
                },
                data: { data: JSON.stringify(accountRequest), recaptchaToken: recaptchaToken },
            });
            // redirect to submission page
            if (result.status === "success") {
                window.location.href = "/account-request-submitted";
            } 
            if (result.status === "user_exists") {
                window.location.href = "/account-request-submitted";
            }
            if (result.status === "request_exists") {
                window.location.href = "/account-request-submitted";
            }
            this.requestAccountBtn.removeClass("d-none");
            this.submitSpinner.addClass("d-none");
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

   /* private showMessage(message: string): void {
        alert(message);
        grecaptcha.reset();
        this.requestAccountBtn.removeClass("d-none");
        this.submitSpinner.addClass("d-none");
    }*/
}

